import { useRedirectIfQuestionnaireUncompleted } from '@/hooks/use-redirect-if-questionnaire-uncompleted';
import { useActionPlan } from '@/queries/action-plan.queries';
import { useCompleteInterventionMutation, useInterventions } from '@/queries/interventions.queries';
import useGetMe from '@/queries/me.queries';
import { Intervention, InterventionStatus } from './types';

export default function useActionPlanController() {
  const { data: userData } = useGetMe();
  const { data: actionPlanData, isLoading: isLoadingActionPlan, refetch } = useActionPlan();
  const completeInterventionMutation = useCompleteInterventionMutation();
  const name = userData?.profile?.name;
  const { interventions, potentialRiskDecrease } = actionPlanData || {};
  const { isLoadingQuestionnaire } = useRedirectIfQuestionnaireUncompleted();
  const { isLoading: isLoadingInterventions } = useInterventions();

  const allInterventionsCompleted =
    !interventions?.length || interventions.every(({ status }) => status === InterventionStatus.COMPLETED);

  const handleCompleteIntervention = async (intervention: Intervention) => {
    try {
      await completeInterventionMutation.mutateAsync({ actionPlanInterventionId: intervention.id });
      await refetch();
    } catch (error) {
      console.error(error);
    }
  };

  const isLoading = isLoadingActionPlan || isLoadingInterventions || isLoadingQuestionnaire;

  return {
    name,
    interventions,
    potentialRiskDecrease,
    isLoading,
    handleCompleteIntervention,
    allInterventionsCompleted,
  };
}
